import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2Unread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="email-2-unread" maskId="round-filled-radius-0-stroke-1.5-IconEmail2Unread"><path d="M21.25 4C21.6642 4.00004 22 4.33581 22 4.75V8C22 8.28323 21.8399 8.54248 21.5869 8.66992L12.3369 13.3301C12.1247 13.4369 11.8743 13.437 11.6621 13.3301L3.5 9.21777V18.5H11.25C11.6642 18.5 12 18.8358 12 19.25C12 19.6642 11.6642 20 11.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75C2 4.33579 2.33579 4 2.75 4H21.25Z" fill="currentColor"/><circle cx="19.5" cy="17.5" r="3.5" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Unread;
